// COMPONENTS
import Login from "./Login";
import Register from "./Register";
import PhysioTracker from "../../Landing/components/PhysioTracker";
import ForgotPassword from "./ForgotPassword";
import AuthContainer from "./AuthContainer";

function Auth({ login = false, signUp = false, forgot = false }) {
  return (
    <AuthContainer>
      {login && <Login />}
      {signUp && <Register />}
      {forgot && <ForgotPassword />}
    </AuthContainer>
  );
}

export default Auth;
